import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { IBeneficiaries } from "./models";
import { beneficiaryItems } from "./beneficiary.mock";
import { memo, useCallback, useState } from "react";
import { Beneficiary } from "./BeneficiaryForm/Beneficiary";

const translationPath = "page.4uDlist.generationRule.beneficiary.";

export const BeneficiaryPage = memo(() => {
  const [beneficiary, setBeneficiary] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const { id } = useParams();
  console.log(selectedId);

  const columns: GridColDef<IBeneficiaries>[] = [
    {
      field: "ownership",
      headerName: t(translationPath + "ownership") || "Ownership",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    setBeneficiary(true);
  };

  const handleRowClick = (params: GridRowParams<IBeneficiaries>) => {
    if (!params.row) return;
    setBeneficiary(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setBeneficiary(false);
  }, []);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {beneficiary && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <Beneficiary id={selectedId} onBackButton={handleBack} />
        </Box>
      )}
      {!beneficiary && (
        <Box height={600}>
          <Table<IBeneficiaries>
            showDefaultMacroFilters={false}
            rows={beneficiaryItems}
            columns={columns}
            title={t(translationPath + "beneficiaries")}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputPlaceHolder={t(translationPath + "search")}
            addButtonLabel={
              t(translationPath + "add_beneficiary") || "Add Beneficiary"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
